/** Move Affiliation out of composable */

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { primeImpactCountries } from '@/helpers/promotion-helper';
import { QTVSimilarTitle } from '@/features/buybox/composables/useQTV';

/** Prime */
const primeSuffixGroups: Record<string, string[]> = {
	/** Associate tags have fixed numerical suffix of 20, 21, or 22 based on country
	 * e.g. amazon-us-qtv-ti-20, amazon-ca-qtv-ft-20
	 */
	'20': ['US', 'CA'],
	'21': ['DE', 'AT', 'FR', 'CH', 'NL', 'ES', 'IT'],
	'22': ['AU', 'JP'],
};

const primeAssociatesSuffixByCountry: Record<string, string> = Object.fromEntries(
	Object.entries(primeSuffixGroups).flatMap(([suffix, countries]) => countries.map(country => [country, suffix]))
);

export function getPrimeTagSuffixByCountry(country: string): string | null {
	return primeAssociatesSuffixByCountry[country] ?? null;
}

function getPrimeQTVTag(placement: 'ft' | 'ti' = 'ti', country: string): string | null {
	const suffix = getPrimeTagSuffixByCountry(country);

	return ['amazon', country.toLowerCase(), 'qtv', placement, suffix].filter(Boolean).join('-');
}

export function getCompositionIdPrefix(shortName: string) {
	if (['amp', 'prv'].includes(shortName)) return 'pv';
	if (shortName === 'atp') return 'qb';

	return shortName;
}

export function updateCTAAffiliation({
	url,
	shortName,
	country,
	compositionId,
}: {
	url: ClickoutUrl;
	shortName: string;
	country: string;
	compositionId: string | null;
}) {
	if (shortName === 'atp') {
		return url.set('uct_ctag2', compositionId);
	}

	if (['amp', 'prv'].includes(shortName)) {
		if (!primeImpactCountries.includes(country)) {
			const tag = getPrimeQTVTag('ft', country);
			url.set('uct_ctag', tag);
		}

		return url.set('r', url.get('r')!.replace('app.primevideo.com', 'www.primevideo.com'));
	}

	return url;
}

export function updatePosterAffiliation({
	url,
	qtvTitle,
	shortName,
	country,
	getCompositionId,
}: {
	url: ClickoutUrl;
	qtvTitle: QTVSimilarTitle;
	shortName: string;
	country: string;
	getCompositionId: (id: string) => string;
}) {
	if (shortName === 'atp') {
		url.set('uct_ctag2', getCompositionId(qtvTitle.id));
	}

	if (['amp', 'prv'].includes(shortName)) {
		if (!primeImpactCountries.includes(country)) {
			const tag = getPrimeQTVTag('ti', country);
			url.set('uct_ctag', tag);
		}

		url.set('r', url.get('r')!.replace('app.primevideo.com', 'www.primevideo.com'));
	}

	return url;
}
